import { SVGProps } from "react"

export const BinocularsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 18" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.325 14.702A7.464 7.464 0 0 0 14.678 12a7.085 7.085 0 0 0 1.234-4.046 7.092 7.092 0 0 0-1.301-4.027 7.475 7.475 0 0 0-3.399-2.648A7.766 7.766 0 0 0 6.863.902a7.599 7.599 0 0 0-3.832 2.02A7.185 7.185 0 0 0 1.007 6.66a7.035 7.035 0 0 0 .467 4.194c.78 1.771 2.254 3.171 4.101 3.893a7.763 7.763 0 0 0 5.75-.045ZM13.703 13.143l5.83 5.632"
    />
  </svg>
)
